module.exports = new __parcel__URL__("elf-title-talent-9.35d247e0.gif").toString();